export const STATUS_CODE = {
    SUCCESS: '000000', // 正常終了コード Code hoàn thành thành công
    GENERAL_ERROR: '999901', // 予期しないエラー lỗi không mong muốn | 予期しないエラーの場合。Trường hợp có lỗi không mong đợi
    PARAMETERS_MISSING: '000001', // パラメータエラー lỗi tham số | リクエストパラメータが不正な場合 Trường hợp các tham số request không đúng
    INVALID_SITE_ID: '000002', // 無効なサイトID ID website vô hiệu | IDが存在しない場合。Trường hợp ID không tồn tại
    FORMAT_ERROR: '000003', // データ登録失敗 đăng kí data thất bại | データ登録に失敗した場合trường hợp thất bại trong việc đăng kí data
    IMAGE_UPLOAD_FAILED: '000004',
    DATA_SYNC_FAILED: '000005'
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/app.const.ts